import { postGroupInviteUser } from "../src/queries";
import { defaultToast } from "./sweet_alert_helper";

export const inviteUserToGroup = (group, user, t, callback) => {
  const Toast = defaultToast;

  postGroupInviteUser(group.token, user.id)
    .then((response) => {
      Toast.fire({
        icon: "success",
        title: t("invitations.invited", { user: user.first_name }),
      });

      if (callback) callback();
    })
    .catch((error) => {
      console.log(error);
    });
};
